import {
  useAppDispatch,
  useAppSelector,
} from "@/app/lib/features/redux/redux.hook";
import { useCallback, useMemo } from "react";
import { getAccountMenu, getHeaderAccountMenu } from "./accountMenu.thunk";
import { isError, isIdle, isLoading, isSuccess } from "@/app/utils/asyncStatus";

const useAccountMenu = () => {
  const dispatch = useAppDispatch();
  const {
    data: menuSections,
    error: menuError,
    status: menuStatus,
    customer: menuCustomer,
    headerMenuData,
    headerMenuStatus,
    headerMenuError,
  } = useAppSelector((store) => store.accountMenu);

  const fetchAccountMenu = useCallback(() => {
    dispatch(getAccountMenu());
  }, [dispatch]);

  const fetchHeaderAccountMenu = useCallback(() => {
    dispatch(getHeaderAccountMenu());
  }, [dispatch]);

  const navSections = useMemo(() => {
    if (!menuSections) return [];
    return menuSections.filter((s) => s.title !== "ÇIKIŞ");
  }, [menuSections]);

  const hasLogout = useMemo(() => {
    if (!menuSections) return false;
    return menuSections.some((s) => s.title === "ÇIKIŞ");
  }, [menuSections]);

  return {
    // Account Menu (sidebar)
    menuSections,
    menuCustomer,
    navSections,
    hasLogout,
    menuError,
    menuStatus,
    isIdle: isIdle(menuStatus),
    isLoading: isLoading(menuStatus),
    isSuccess: isSuccess(menuStatus),
    isError: isError(menuStatus),
    fetchAccountMenu,

    // Header Account Menu
    headerMenuData,
    headerMenuStatus,
    headerMenuError,
    isHeaderMenuIdle: isIdle(headerMenuStatus),
    isHeaderMenuLoading: isLoading(headerMenuStatus),
    isHeaderMenuSuccess: isSuccess(headerMenuStatus),
    isHeaderMenuError: isError(headerMenuStatus),
    fetchHeaderAccountMenu,
  };
};

export default useAccountMenu;
